(function(exports) {
  exports.noop = function(){};
})(typeof module === 'object' && typeof module.exports === 'object' ? module.exports : window);



//////////////////
// WEBPACK FOOTER
// ./~/node-noop/index.js
// module id = 1171
// module chunks = 0